import fetch from '@/utils/fetch';
// import {api_url} from "../popular/index"
const api_url = process.env.VUE_APP_API;

export const user_info = () => fetch({//用户页顶部信息
  url: `${api_url}/users`,
});

export const user_table = data => fetch({//分页查询组织信息
  url: `${api_url}/manager/user`,
  method: 'post',
  data ,
});

export const user_detail = data => fetch({//用户页顶部信息
  url: `${api_url}/manager/user/${data.userId}`,
});